import { makeStyles } from 'tss-react/mui';

const name = 'Header';

export const useHeaderStyles = makeStyles({ name })(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',

    gap: theme.spacing(3),
  },
  topRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',

    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',

      gap: theme.spacing(5),
    },
  },
  left: {
    display: 'flex',
    gap: theme.spacing(1.5),

    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  timeframes: {
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  statisticsButton: {
    display: 'flex',
    gap: theme.spacing(2),
    height: 30,
    minHeight: 30,

    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  icon: {
    '& > path': {
      strokeWidth: 2,
    },
  },
  selectors: {
    paddingBottom: theme.spacing(4),

    borderBottom: `1px solid ${theme.palette.divider}`,

    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      gap: theme.spacing(3),

      paddingBottom: 0,

      borderBottom: '0 none',
    },
  },
}));
